var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTouchpointsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58281 2.33334V1.16667C10.3011 1.45834 12.442 3.61084 12.7453 6.32917C13.0953 9.53167 10.7911 12.4133 7.58281 12.7633V11.5967C9.70615 11.3342 11.3745 9.66001 11.6428 7.53667C11.7184 6.92836 11.6733 6.31111 11.5101 5.72025C11.3468 5.12939 11.0687 4.5765 10.6916 4.09322C10.3146 3.60994 9.84589 3.20575 9.31244 2.90377C8.779 2.60179 8.19124 2.40795 7.58281 2.33334ZM3.30698 2.45001C4.19122 1.72011 5.27451 1.27297 6.41615 1.16667V2.36834C5.58198 2.48501 4.79448 2.82334 4.14115 3.34834L3.30698 2.45001ZM1.19531 6.41667C1.30328 5.27439 1.75248 4.19104 2.48448 3.30751L3.31865 4.14167C2.80138 4.80042 2.47093 5.58623 2.36198 6.41667H1.19531ZM2.49031 10.6925C1.76562 9.80458 1.31739 8.72354 1.20115 7.58334H2.36781C2.47281 8.41167 2.80531 9.19917 3.31865 9.85834L2.49031 10.6925ZM3.30698 11.515L4.11781 10.7158H4.14115C4.80031 11.2292 5.58781 11.5617 6.41615 11.6667V12.8333C5.27281 12.7108 4.18781 12.25 3.30698 11.515ZM6.99948 9.91667L7.90948 7.92167L9.91615 7.00001L7.90948 6.09001L6.99948 4.08334L6.08365 6.09001L4.08281 7.00001L6.08365 7.92167L6.99948 9.91667Z",
    fill: "#E4002B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTouchpointsIcon);
export default __webpack_public_path__ + "static/media/touchpointsIcon.04e94edb034e0990a0523878ae9b3267.svg";
export { ForwardRef as ReactComponent };